export const convertToArray = (value: unknown) => {
  if (typeof value !== 'string') return value

  const values = value.split(',')

  return values.map(v => v.trim())
}
